<p-avatarGroup
  class="b-useravatargroup"
  (click)="additionalUsersList.toggle($event)"
>
  <ng-container *ngFor="let user of users; index as i">
    <p-avatar
      *ngIf="i < 4 && user.userProfileImage"
      shape="circle"
      [image]="user.userProfileImage"
    ></p-avatar>
    <p-avatar
      *ngIf="i < 4 && !user.userProfileImage"
      shape="circle"
      [label]="getUserInitials(user?.firstName, user?.lastName)"
    ></p-avatar>
  </ng-container>
  <p-badge
    *ngIf="users?.length > 4"
    [value]="getAdditionalUserCount(users?.length)"
  ></p-badge>
</p-avatarGroup>

<p-overlayPanel #additionalUsersList styleClass="b-useravatargroup-userlist">
  <ng-template pTemplate>
    <p-dataView [value]="users">
      <ng-template let-users pTemplate="list">
        <ng-container *ngFor="let user of users">
          <basin-list-item
            [primaryLine]="getUserNameString(user.firstName, user.lastName)"
          >
            <p-avatar
              leftSection
              *ngIf="user.userProfileImage"
              class="b-avatargroup-userprofileimage"
              shape="circle"
              [image]="user.userProfileImage"
            ></p-avatar>
            <p-avatar
              leftSection
              *ngIf="!user.userProfileImage"
              class="b-avatargroup-userprofileimage"
              shape="circle"
              [label]="getUserInitials(user.firstName, user.lastName)"
            ></p-avatar>
          </basin-list-item>
        </ng-container>
      </ng-template>
    </p-dataView>
  </ng-template>
</p-overlayPanel>
